import { Fragment } from 'react';

import {
  AccordionSummary,
  Grid,
  Accordion as MuiAccordion,
  Typography,
} from '@frontierag/frontier-ui-library';
import { ExpandMore as ExpandMoreIcon } from '@frontierag/frontier-ui-library/icons';
import useDataFieldHelpers from 'hooks/useDataFieldHelpers';

import AccordionDynamicCells from './AccordionDynamicCells';
import AccordionRowActions from './AccordionRowActions';
import { styles } from './styles';
import type { IAccordionRow } from './types';

export default function AccordionRow({
  data,
  fixedCells,
  dynamicCells,
  defaultExpanded = true,
  actionCells = [],
  sx,
  accordionChildren,
  ...rest
}: IAccordionRow) {
  const { renderValue, renderLabel } = useDataFieldHelpers(data);

  return (
    <MuiAccordion
      data-testid={`accordion-row`}
      defaultExpanded={defaultExpanded}
      elevation={0}
      sx={[styles.accordionRow, ...(Array.isArray(sx) ? sx : [sx])]}
      {...rest}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={styles.accordionSummary}
        data-testid="accordion-row-summary"
      >
        <Grid direction="row" xs={12} container item spacing={0.5} alignItems="baseline">
          {fixedCells.map((field, index) => (
            <Fragment key={`fixed-row-${index}`}>
              <Grid item xs={5}>
                <Typography variant="label2" data-testid={`${field.name}-label`}>
                  {renderLabel(field)}:
                </Typography>
              </Grid>
              <Grid item xs={7} sx={{ fontSize: '14px' }} data-testid={`${field.name}-value`}>
                {renderValue(field)}
              </Grid>
            </Fragment>
          ))}
        </Grid>
      </AccordionSummary>
      <AccordionDynamicCells data={data} dynamicCells={dynamicCells} />
      {accordionChildren && accordionChildren(data)}
      <AccordionRowActions data={data} actionCells={actionCells} />
    </MuiAccordion>
  );
}
